// PD-819 (demostaff stream; owner decision PD-800): in demo mode staff and console changes run in the
// browser's sandbox and are never saved. Success messages that would say "saved", "in force" or "the
// host is notified" are replaced by truthful demo variants (same parameters) wherever a page shows
// them, so no page needs its own demo branch. The demo notice ("Demo: this worked for you only …")
// is shown as well (PD-776).
import type { MessageKey, MsgRef } from '@passage/i18n';

export const DEMO_COPY: Readonly<Partial<Record<MessageKey, MessageKey>>> = {
  'set.saved': 'demo.staff.settingSaved',
  'opsui.hours.saved': 'demo.staff.saved',
  'opsui.rules.saved': 'demo.staff.saved',
  'ver.set.saved': 'demo.staff.saved',
  'vpolicy.saved': 'demo.staff.draftSaved',
  'vpolicy.published': 'demo.staff.published',
  'ppl.dict.published': 'demo.staff.published',
  'brand.saved': 'demo.staff.versionSaved',
  'settings.saved': 'demo.staff.versionSaved',
  'gate.register.note': 'demo.staff.hostNotTold',
};

/** The message a demo shows instead of `ref` (unchanged when there is no demo variant). */
export function demoCopy(ref: MsgRef): MsgRef {
  if (typeof ref === 'string') return DEMO_COPY[ref] ?? ref;
  const swap = DEMO_COPY[ref.key];
  return swap ? { ...ref, key: swap } : ref;
}
